import { render, staticRenderFns } from "./ImageProfile.vue?vue&type=template&id=3c6790e6"
import script from "./ImageProfile.vue?vue&type=script&lang=js"
export * from "./ImageProfile.vue?vue&type=script&lang=js"
import style0 from "./ImageProfile.vue?vue&type=style&index=0&id=3c6790e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports